// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__20WJ_","content":"RecentSearches_content__3v2Mi"};